module.exports = __webpack_public_path__ + "static/product-page-hero-0aaa97ec022217552245315e9eeb04ea.jpg";